<template>
  <div class="container_box details_box_styles">
    <!-- 逻辑说明 -->
    <div style="margin-bottom: 25px;">
      <Row type="flex" justify="center" class="code-row-bg">
        <Col span="12">
          <h2 class="text-center font-size-18 font-weight-bold">{{ $t('key1005358') }}</h2>
        </Col>
      </Row>
      <div class="explain_box" :class="pageType === 'distributor' ? 'distributorTheme' : 'ymsTheme'">
        <!--匹配物流渠道基础属性-->
        <div class="explain_box_item">
          <h2 class="title">{{ $t('key1005359') }}</h2>
          <Tooltip theme="light" max-width="260" class="tooltip_box_style" transfer>
            <Icon type="md-help-circle" size="20" class="cursor" :color="pageType === 'distributor' ? '#FD5425' : '#32a6d9'"/>
            <template #content>
              <div>
                <h3>{{ $t('key1005360') }}</h3>
                <p>{{ $t('key1005361') }}</p>
                <p>{{ $t('key1005362') }}</p>
                <p>{{ $t('key1005363') }}</p>
                <p>{{ $t('key1005364') }}</p>
                <p>{{ $t('key1005365') }}</p>
                <p style="marginTop:5px;">{{ $t('key1005366') }}</p>
                <p>{{ $t('key1005367') }}</p>
              </div>
            </template>
          </Tooltip>
        </div>
        <Icon type="md-arrow-round-forward" size="24" :color="themeColor" style="margin: 0 20px;"/>
        <!--匹配物流规则-->
        <div class="explain_box_item">
          <h2 class="title">{{ $t('key1005368') }}</h2>
          <Tooltip theme="light" max-width="260" class="tooltip_box_style" transfer>
            <Icon type="md-help-circle" size="20" class="cursor" :color="pageType === 'distributor' ? '#FD5425' : '#32a6d9'"/>
            <template #content>
              <p>{{ $t('key1005369') }}</p>
              <p style="marginTop:5px;">{{ $t('key1005366') }}</p>
            </template>
          </Tooltip>
        </div>
        <Icon type="md-arrow-round-forward" size="24" :color="themeColor" style="margin: 0 20px;"/>
        <!--匹配物流适用范围-->
        <div class="explain_box_item">
          <h2 class="title">{{ $t('key1005370') }}</h2>
          <Tooltip theme="light" max-width="260" class="tooltip_box_style" transfer>
            <Icon type="md-help-circle" size="20" class="cursor" :color="pageType === 'distributor' ? '#FD5425' : '#32a6d9'"/>
            <template #content>
              <h3>{{ $t('key1005371') }}</h3>
              <p>{{ $t('key1005372') }}</p>
              <p style="marginTop:5px;">{{ $t('key1005366') }}</p>
            </template>
          </Tooltip>
        </div>
        <Icon type="md-arrow-round-forward" size="24" :color="themeColor" style="margin: 0 20px;"/>
        <!--运费/时效优先级-->
        <div class="explain_box_item">
          <h2 class="title">{{ $t('key1005373') }}</h2>
          <Tooltip theme="light" max-width="260" class="tooltip_box_style" transfer>
            <Icon type="md-help-circle" size="20" class="cursor" :color="pageType === 'distributor' ? '#FD5425' : '#32a6d9'"/>
            <template #content>
              <h3>{{ $t('key1005374') }}</h3>
              <p>{{ $t('key1005375') }}</p>
            </template>
          </Tooltip>
        </div>
      </div>
    </div>
    <!-- 仓库 -->
    <div class="warehouse_box_styls" v-if="pageType !== 'distributor'">
      <span class="text">{{ $t('key1000333') }}</span>
      <Button-group>
        <template v-for="(item, index) in wareGroup" v-if="index < 5">
          <Button v-if="item.selected" type="primary" @click="getPlatformData(item.warehouseId)" :key="index">{{ item.title }}</Button>
          <span class="pseudoButton" v-if="!item.selected" @click="getPlatformData(item.warehouseId)" :key="index">{{ item.title }}</span>
        </template>
        <template v-if="wareGroup.length > 5">
          <Dropdown style="margin-left: 10px;" transfer>
            <Button>{{ moreTitle }}
              <Icon type="md-arrow-dropdown"/>
            </Button>
            <template #list>
              <Dropdown-menu>
                <Dropdown-item
                  v-for="(item, index) in wareGroup" v-if="index >= 5" :key="item.id">
                  <div @click="getPlatformData(item.warehouseId)">{{ item.title }}</div>
                </Dropdown-item>
              </Dropdown-menu>
            </template>

          </Dropdown>
        </template>
      </Button-group>
    </div>
    <!-- 物流规则 -->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover class="reset_card_head_style">
        <template #title>
          <div class="options_box_style">
            <h2 class="title_box">{{ $t('key1001336') }}</h2>
            <Button
              type="primary"
              v-if="getPermission('ymsCarrierAutoRule_insert')"
              @click="addRule"
              style="marginLeft:15px;">
              {{ $t('key1005376') }}
            </Button>
          </div>
        </template>
        <Form inline @submit.native.prevent>
          <Form-item :label="$t('key1000461')">
            <Select class="f-wid" v-model="searchParams.status">
              <Option v-for="(item,index) in statusList" :value="item.value" :key="index">{{ item.label }} </Option>
            </Select>
          </Form-item>
          <Form-item :label="$t('key1005348')">
            <Select filterable class="f-wid" multiple v-model="searchParams.platformIds">
              <Option
                v-for="item in platformList"
                :value="item.platformId"
                :key="item.platformId">{{ item.name }}
              </Option>
            </Select>
          </Form-item>
          <Form-item :label="$t('key1005349')" :class="system === 'distributor' ? 'distributorTreeStyle': ''">
            <treeSelect
              :treeData="countryData"
              ref="treeDataRef"
              v-model="countryCodes"
              filterable
              @on-change="getTreeData"
              class="f-wid treeSelect_box"
              show-checkbox>
            </treeSelect>
          </Form-item>
          <Form-item :label="$t('key1005350')">
            <Cascader
              v-if="pageType !== 'distributor'"
              :data="shippingMethodData"
              class="f-wid"
              @on-visible-change="getCarrierFn"
              v-model="value2"
              :load-data="loadDataFn"
              @on-change="getAccountApiMatch">
            </Cascader>
            <Select
              v-else
              filterable
              :placeholder="$t('key1001359')"
              multiple
              class="f-wid"
              @on-change="selectYmsLogisServiceId"
              v-model="shippingMethodIds">
              <Option v-for="yun in yunShipList" :value="yun.ymsLogisServiceId">{{ yun.name }}</Option>
            </Select>
          </Form-item>
          <Button size="small" type="primary" class="smart-search" @click="search">{{ $t('key1000011') }}</Button>
        </Form>
        <div v-if="shippingParamsList.length > 0" class="mt10 mb10">
          <span>{{ $t('key1005377') }}</span>
          <Tag v-for="(item,index) in shippingParamsList" :key="item.id">
            {{ item.name }}
            <Icon type="ios-close" class="ml10" @click="delShipFn(index)"/>
          </Tag>
        </div>
        <div class="table_box">
          <Table
            ref="dragable"
            highlight-row
            border
            :columns="logisticsColumns"
            :loading="tableLoading"
            :data="logisticsData">
          </Table>
        </div>
      </Card>
    </div>
    <!-- 物流渠道适用范围 -->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005378') }}</h2>
        </template>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="400"
            :columns="scopeColumns"
            :loading="scopeLoading"
            :data="scopeData">
          </Table>
        </div>
      </Card>
    </div>
    <!--  优先级 -->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005373') }}</h2>
        </template>
        <div class="moveDragContainer flex justify-content-center align-items-center" style="display: flex" id="moveDragContainer">
          <div class="moveDrag priority_box" v-for="(item, index) in dataList" :key="index">
            <Icon type="md-move" class="normalRMargin"></Icon>
            <span>{{ timePriorityMap[item] }}</span>
            <Icon v-if="index+1 !== dataList.length" type="ios-arrow-forward" style="position:absolute;left:50%;"/>
          </div>
        </div>
      </Card>
    </div>
    <!-- 适用范围弹窗 -->
    <Modal v-model="scopeModal" :width="ownLogistics ? 450 : 1000" :title="$t('key1005341')" @on-ok="saveScope"
      @on-visible-change="scopeModalChange" :loading="scopeModalLoading">
      <Form ref="rangeOfApplicationParmas" :model="rangeOfApplicationParams" label-position="right"
        :label-width="ownLogistics ? 90 : 140" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem" style="width: 95%; margin-right: 60px">
          <Col :xxl="ownLogistics ? oneItemCol : twoItemCol" :xl="ownLogistics ? oneItemCol : twoItemCol"
            :lg="ownLogistics ? oneItemCol : twoItemCol" :md="ownLogistics ? oneItemCol : twoItemCol">
            <FormItem :label="$t('key1005351')">
              <span v-if="extendJsonTalg">{{ platformIds.join('、') }}</span>
              <Select v-model="platformIds" multiple @on-change="scopePlatformChange" filterable v-else>
                <Option v-for="item in platformList" :value="item.platformId" :label="item.name"></Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="ownLogistics ? oneItemCol : twoItemCol" :xl="ownLogistics ? oneItemCol : twoItemCol"
            :lg="ownLogistics ? oneItemCol : twoItemCol" :md="ownLogistics ? oneItemCol : twoItemCol" v-if="pageType === 'distributor'">
            <FormItem :label="$t('key1005352')">
              <Select v-model="accountIds" multiple filterable>
                <Option v-for="item in platformAccountList" :value="item.ymsPlatformAccountId" :label="item.code"></Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol" v-if="!ownLogistics">
            <FormItem :label="$t('key1005353')">
              <InputNumber class="width120" v-model="carrierShippingMethodParmas.minPrice" :min="0" :max="999999999"></InputNumber>
              <span> - </span>
              <InputNumber class="width120" v-model="carrierShippingMethodParmas.maxPrice" :min="0" :max="999999999"></InputNumber>
            </FormItem>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol" v-if="system === 'distributor' && !ownLogistics">
            <FormItem :label="$t('key1005354')">
              <InputNumber class="width120" v-model="carrierShippingMethodParmas.minShippingFeeIncome" :min="0" :max="999999999"></InputNumber>
              <span> - </span>
              <InputNumber class="width120" v-model="carrierShippingMethodParmas.maxShippingFeeIncome" :min="0" :max="999999999"></InputNumber>
            </FormItem>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol" v-if="!ownLogistics">
            <FormItem :label="$t('key1005355')">
              <Input v-model.trim="skuList" type="textarea" :rows="4" :placeholder="$t('key1005356')"></Input>
            </FormItem>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol" v-if="!ownLogistics">
            <FormItem :label="$t('key1005357')">
              <InputNumber class="width120" v-model="carrierShippingMethodParmas.minGoodsQuantity" :min="0"></InputNumber>
              <span> - </span>
              <InputNumber class="width120" v-model="carrierShippingMethodParmas.maxGoodsQuantity" :min="0"></InputNumber>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="scopeModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="saveScope">{{ $t('key1000555') }}</Button>
      </template>
    </Modal>
    <ruleTemp ref="ruleTemp" :ruleType="ruleType" :selectWareID="selectWareID" @saveCallback="search"></ruleTemp>
  </div>
</template>
<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import ruleMixin from '@/components/mixin/rule_mixin';
import Sortable from 'sortablejs';
import publicService from '@/components/mixin/publicService_mixin';
import ruleTemp from '@/components/common/ruleTemp';
import {
  getUserNameByUserId, getOwnLogisticsChannel, getEnableWarehouseData, getRegionalRcountriesData,
  _handleMultilingualFields, getEnabledPlatforms, getAllUsersInfo, getYunLogisticsAll, getDataSetList
} from "@/utils/common";

let sortEl;
export default {
  mixins: [Mixin, publicService, ruleMixin],
  components: {
    ruleTemp
  },
  props: {
    pageType: {
      type: String  // distributor 分销商 智能物流规则
    }
  },
  data() {
    let self = this;
    return {
      shippingMethodIds: null,
      ruleType: 'smartLogistics',
      looKsettings: false,
      countryData: [],
      countryCodes: [],
      platformList: [],
      platformIds: [],
      accountIds: [],
      searchParams: {
        'businessId': '', // 业务Id 智能物流为仓库id ,
        'countryCodes': [], //  国家编码集合
        'platformIds': [], // 平台ids
        'shippingMethodIds': [], // 邮寄方式集合
        'status': 1 // 状态 1启用 0停用 全部-1 ,
      },
      statusList: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: -1},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'), value: 1},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'), value: 0}
      ],
      editType: '1', // 0 编辑 1 创建
      dataList: ['LF', 'FT'],
      typeList: ['LF', 'FT'],
      moreTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005338'),
      wareGroup: [], // 仓库列表
      selectWareID: null, // 当前选择仓库Id
      // 物流规则
      tableLoading: false,
      logisticsData: [],
      logisticsColumns: [
        {
          type: 'selection',
          width: 70,
          align: 'center'
        }, {
          title: 'No.',
          type: 'index',
          width: 75,
          align: 'center'
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002152'),
          width: 200,
          align: 'center',
          render: (h, params) => {
            let arr = [];
            arr = [
              h('span', {
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002153')
                },
                domProps: {
                  innerHTML: (() => {
                    return self.pageType === 'distributor' ? '&#xe670;' : '&#xe68a;';
                  })()
                },
                style: {
                  margin: '0 4px',
                  display: (() => {
                    return self.logisticsData.length > 1 ? 'inline-block' : 'none';
                  })()
                },
                class: 'icon iconfont icon-setBottom-copy normalFontSizeTwoSize cursor greenColor',
                on: {
                  click: () => {
                    self.tableSort(params.row.autoRuleId, self.logisticsData.length - 1, params.index);
                  }
                }
              }), h('span', {
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002154')
                },
                domProps: {
                  innerHTML: (() => {
                    return self.pageType === 'distributor' ? '&#xe63c;' : '&#xe687;';
                  })()
                },
                style: {
                  margin: '0 4px',
                  display: (() => {
                    return self.logisticsData.length > 1 ? 'inline-block' : 'none';
                  })()
                },
                class: 'icon iconfont normalFontSizeTwoSize cursor blueColor',
                on: {
                  click: () => {
                    self.tableSort(params.row.autoRuleId, 0, params.index);
                  }
                }
              }), h('Icon', {
                props: {
                  type: 'md-move',
                  size: 18
                },
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005339')
                },
                style: {
                  margin: '0 4px',
                  position: 'relative',
                  top: '-2px',
                  display: (() => {
                    return self.logisticsData.length > 1 ? 'inline-block' : 'none';
                  })()
                },
                class: 'cursor-move grayColor'
              })

            ];
            if (params.index === 0) {
              arr.splice(1, 1);
            } else if (params.index === self.logisticsData.length - 1) {
              arr.splice(0, 1);
            }
            return h('div', {
              style: {
                display: (() => {
                  return self.getPermission('ymsCarrierAutoRule_updatePriority') ? 'flex' : 'none';
                })(),
                alignItems: 'center',
                justifyContent: 'center'
              }
            }, arr);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002156'),
          minWidth: 100,
          align: 'center',
          key: 'name'
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return params.row.status === 0 ? h('span', {
              class: 'redColor'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')) : h('span', {
              class: 'greenColor'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'));
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003560'),
          minWidth: 120,
          maxWidth: 200,
          align: 'center',
          key: 'updatedBy',
          render: (h, params) => {
            return h('span', getUserNameByUserId(params.row.updatedBy, self.userInfoList));
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002971'),
          minWidth: 200,
          maxWidth: 240,
          align: 'center',
          key: 'updateTime',
          sortable: true,
          render: (h, params) => {
            return h('span', self.$uDate.dealTime(params.row.updatedTime, 'fulltime'));// return last update time
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'operate',
          align: 'center',
          width: 220,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: self.getPermission('ymsCarrierAutoRule_detail'),
                    clickFn: () => {
                      self.ruleTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002168') + '(' + params.row.name + ')';
                      self.ruleEditStatus = true;
                      self.looKsettings = true;
                      self.$nextTick(function () {
                        self.ruleEditModel = true;
                        self.ruleParmas = {
                          editType: 'look',
                          autoRuleId: params.row.autoRuleId,
                          warehouseId: params.row.warehouseId,
                          name: params.row.name,
                          status: params.row.status,
                          businessId: self.selectWareID
                        };
                        self.$refs.ruleTemp.open(self.ruleParmas);
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: self.getPermission('ymsCarrierAutoRule_update'),
                    clickFn: () => {
                      self.ruleTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002169') + '(' + params.row.name + ')';
                      self.ruleEditStatus = true;
                      self.looKsettings = false;
                      self.$nextTick(function () {
                        self.ruleEditModel = true;
                        self.ruleParmas = {
                          editType: 'edit',
                          autoRuleId: params.row.autoRuleId,
                          warehouseId: params.row.warehouseId,
                          name: params.row.name,
                          status: params.row.status,
                          businessId: self.selectWareID
                        };
                        self.$refs.ruleTemp.open(self.ruleParmas);
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: params.row.status === 0 && self.getPermission('ymsCarrierAutoRule_enable'),
                    clickFn: () => {
                      self.setStatus(params.row.autoRuleId, 0);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: params.row.status === 1 && self.getPermission('ymsCarrierAutoRule_disable'),
                    clickFn: () => {
                      self.setStatus(params.row.autoRuleId, 1);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: self.getPermission('ymsCarrierAutoRule_delete'),
                    clickFn: () => {
                      self.delRuleFn([params.row.autoRuleId]);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    self.optionBtnWidth.push(value);
                    params.column.width = Math.max(...self.optionBtnWidth);
                    self.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      ruleEditModel: false,
      ruleEditStatus: false,
      ruleLoading: false,
      ruleTitle: null,
      ruleParmas: null,
      timestamp: 0,
      scopeLoading: false,
      scopeData: [],
      scopeColumns: [
        {
          type: 'selection',
          width: 70,
          align: 'center'
        },
        {
          title: 'No.',
          width: 75,
          align: 'center',
          type: 'index'
        },
        {
          title: self.pageType === 'distributor' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000222') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005340'),
          minWidth: 120,
          align: 'center',
          key: 'carrierName',
          render: (h, params) => {
            if (self.pageType === 'distributor') {
              return h('div', params.row.ymsLogisticsName);
            } else {
              let carrierShippingMethodName = _handleMultilingualFields(params.row.carrierShippingMethodName);
              return h('div', [
                h('div', params.row.carrierName),
                h('div', carrierShippingMethodName)
              ]);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005341'),
          minWidth: 150,
          align: 'center',
          key: 'scopeExtent',
          render: (h, params) => {
            let pos = [];
            let isOwnLogistics = params.row.isOwnLogistics;
            let ymsLogisServiceScopePlatformList = params.row.ymsLogisServiceScopePlatformList || [];
            // 自有物流
            if (isOwnLogistics) {
              let list = [];
              if (ymsLogisServiceScopePlatformList.length > 0) {
                let newList = self.handerGrouping(ymsLogisServiceScopePlatformList, function (item) {
                  return [item.platformId];
                }, 'platformId', 'data');
                if (newList.length > 0) {
                  newList.map((item) => {
                    let saleAccountNameList = [];
                    if (item.data.length > 0) {
                      item.data.map((ele) => {
                        if (ele.saleAccountName) {
                          saleAccountNameList.push(ele.saleAccountName);
                        }
                      });
                    }
                    list.push(
                      h('p', [
                        h('span', saleAccountNameList.length > 0 ? item.platformId + '：' : item.platformId),
                        saleAccountNameList.length > 0 ? h('span', saleAccountNameList.join('、')) : ''
                      ])
                    );
                  });
                }
              }
              return h('div', list);
            }
            // 云卖物流
            else {
              if (this.pageType === 'distributor') {
                if (params.row.ymsLogisServiceScopePlatformList) {
                  pos.push(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005342'));
                }
              } else {
                if (params.row.ymsCarrierScopePlatformList) {
                  pos.push(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005342'));
                }
              }
              if (params.row.tagNameList) {
                pos.push(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003304'));
              }
              if (params.row.minPrice > 0 || params.row.maxPrice > 0) {
                pos.push(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599'));
              }
              if (self.system === 'distributor') {
                if (params.row.minShippingFeeIncome > 0 || params.row.maxShippingFeeIncome > 0) {
                  pos.push(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005343'));
                }
              }
              if (params.row.skuList) {
                pos.push(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005344'));
              }
              if (params.row.minGoodsQuantity > 0 || params.row.maxGoodsQuantity > 0) {
                pos.push(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005345'));
              }
              if (pos.length) {
                return h('div', pos.toString());
              } else {
                return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005346'));
              }
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003560'),
          minWidth: 120,
          maxWidth: 200,
          align: 'center',
          key: 'updatedBy',
          render: (h, params) => {
            return h('span', getUserNameByUserId(params.row.updatedBy, self.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002971'),
          minWidth: 200,
          maxWidth: 240,
          align: 'center',
          key: 'updateTime',
          sortable: true,
          render: (h, params) => {
            return h('span', self.$uDate.dealTime(params.row.updatedTime, 'fulltime'));// return last update time
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'operate',
          align: 'center',
          width: 78,
          render: (h, params) => {
            let isOwnLogistics = params.row.isOwnLogistics;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: self.getPermission('ymsCarrierScopeRule_update'),
                    clickFn: () => {
                      // 自有物流
                      if (isOwnLogistics) {
                        self.ownLogistics = true;
                        // 判断当前物流渠道是否设置适用平台范围
                        let extendJson = params.row.extendJson ? JSON.parse(params.row.extendJson) : [];
                        self.extendJsonTalg = extendJson.length > 0 ? true : false;
                        self.editRowData(params.row);
                      }
                      // 云卖物流
                      else {
                        self.editType = '0';
                        self.carrierShippingMethodParmas = {
                          maxPrice: null,
                          minPrice: 0,
                          maxShippingFeeIncome: null,
                          minShippingFeeIncome: 0,
                          minEfficiency: 0,
                          maxEfficiency: 0,
                          minGoodsQuantity: 0,
                          maxGoodsQuantity: null
                        };
                        self.editRowData(params.row);
                      }
                    }
                  }
                ]
              }
            });
          }
        }
      ],
      scopeModal: false,
      shopAccount: [],
      rangeOfApplicationParams: null,
      shopAccountListModel: [],
      skuList: '',
      carrierShippingMethodParmas: {
        maxPrice: null,
        minPrice: 0,
        maxShippingFeeIncome: null,
        minShippingFeeIncome: 0,
        minEfficiency: 0,
        maxEfficiency: 0,
        minGoodsQuantity: 0,
        maxGoodsQuantity: null
      },
      platformGroup: null,
      rowData: [],
      scopeModalLoading: true,
      warehouseType: '0',
      value2: [],
      shippingParamsList: [],
      ownLogistics: false, // 是否是自有物流  默认false
      extendJsonTalg: false,
      ymsScopeLogisticsChannelData: [],
      userInfoList: {},
      yunShipList: [],
      timePriorityMap: {}
    };
  },
  computed: {
    // 区分主题颜色
    themeColor() {
      // 分销商系统
      if (this.pageType === 'distributor') {
        return '#FD5425';
      }
      // 运营系统
      else {
        return '#32a6d9';
      }
    }
  },
  created() {
    let v = this;
    v.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await getRegionalRcountriesData().then((list) => {
          v.getCommonCountry(list, v.treeArr).then(data => {
            v.countryData = data;
          });
        });
        if (v.pageType === 'distributor') {
          v.ruleType = 'distributorSmart';
          v.yunShipList = await getYunLogisticsAll();
          await v.getTimePriorityList('YmsLogisServiceProposalRuleTypeDistributorEnum');
          await v.search();
          await v.getCarrierRule();
          await v.getCarrierScope();
          v.platformList = await getEnabledPlatforms();
        } else {
          await v.getTimePriorityList('YmsCarrierProposalRuleTypeCoreEnum');
          await v.getWareHouseNameList(); // 获取仓库列表
          v.platformList = [{
            platformId: 'ebay',
            name: 'ebay',
          }];
        }
      })();
    },
    // 获取运费、时效优先级数据集
    async getTimePriorityList(paramsKey) {
      let timePriorityList = await getDataSetList(paramsKey);
      let obj = {};
      timePriorityList.forEach(item => {
        obj[item.value] = item.name;
      });
      this.timePriorityMap = obj;
    },
    search() {
      this.searchParams.businessId = this.selectWareID;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      if (this.pageType !== 'distributor') {
        params.shippingMethodIds = this.shippingParamsList.map(i => i.id);
      } else {
        params.shippingMethodIds = this.shippingMethodIds;
      }
      this.getLogisticsData(params);
    },
    delShipFn(index) {
      this.shippingParamsList.splice(index, 1);
    },
    getAccountApiMatch(value) {
      this.shippingParamsList.push({
        name: value[0].carrierName + '/' + value[1].carrierShippingMethodName,
        id: value[1].shippingMethodId
      });
      setTimeout(() => {
        this.value2 = [];
      }, 30);
    },
    getCarrierFn() {
      this.getCarrierList(this.selectWareID, this.wareGroup).then(data => {
        let pos = [];
        for (let i = 0; i < data.length; i++) {
          pos.push({
            value: data[i],
            label: data[i].carrierName,
            children: [],
            loading: false,
            carrierAccounts: data[i].carrierAccounts,
            apiInterface: data[i].apiInterface
          });
          if (i === data.length - 1) {
            this.shippingMethodData = pos;
          }
        }
      });
    },
    getYmsLogisticsNameByIds(ids) {
      let v = this;
      return new Promise(resolve => {
        let url = v.system === 'yms' ? api.post_ymsLogisService_queryByIds : api.post_ymsLogisService_api_queryByIds;
        v.axios.post(url, ids).then(response => {
          if (response.data.code === 0) {
            resolve(response.data.datas);
          }
        });
      });
    },
    getCarrierList(warehouseId, warehouseIdList) {
      /**
       * 返回当前仓库下面的物流方式分类
       * @params （必需） warehouseId 仓库id
       * @params （必需） warehouseIdList 仓库列表
       * */
      let v = this;
      let warehouseType = warehouseIdList.filter(i => {
        if (i.warehouseId === warehouseId) {
          return i;
        }
      })[0].warehouseType;
      return new Promise(resolve => {
        v.axios.get(api.get_enableCarriers + '?warehouseId=' + warehouseId + '&isFilter=true' + '&warehouseType=' + warehouseType).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              resolve(data);
            }
          }
        });
      });
    },
    loadDataFn(item, callback) {
      this.getCarrierShippingList(item.value.carrierId, this.selectWareID).then((data) => {
        let pos = [];
        for (let i = 0; i < data.length; i++) {
          pos.push({
            value: data[i],
            label: data[i].carrierShippingMethodName
          });
          if (i === data.length - 1) {
            item.children = pos;
            item.loading = false;
          }
        }
        callback();
      });
    },
    getTreeData() {
      let v = this;
      let nodesArr = v.$refs['treeDataRef'].getCheckedNodes();
      let arr = [];
      nodesArr.forEach((n, i) => {
        if (n.hasOwnProperty('zoneCode')) {
          arr.push(n.zoneCode);
        }
      });
      v.searchParams.countryCodes = arr;
    },
    delRuleFn(autoRuleIds) {
      let v = this;
      v.isDelModal(() => {
        let apiUrl = v.pageType === 'distributor' ? api.delete_ymsLogisServiceAutoRule : api.delete_ymsCarrierAutoRule;
        v.axios.delete(apiUrl + '?autoRuleIds=' + autoRuleIds).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
            v.pageParamsStatus = true;
            v.selectTabData = [];
            v.search();
          }
        });
      });
    },
    setNumber() {
      if (this.carrierShippingMethodParmas.minPrice > this.carrierShippingMethodParmas.maxPrice) {
        [
          this.carrierShippingMethodParmas.minPrice, this.carrierShippingMethodParmas.maxPrice
        ] = [this.carrierShippingMethodParmas.maxPrice, this.carrierShippingMethodParmas.minPrice];
      }
      if (this.system === 'distributor') {
        if (this.carrierShippingMethodParmas.minShippingFeeIncome > this.carrierShippingMethodParmas.maxShippingFeeIncome) {
          [
            this.carrierShippingMethodParmas.minShippingFeeIncome, this.carrierShippingMethodParmas.maxShippingFeeIncome
          ] = [
            this.carrierShippingMethodParmas.maxShippingFeeIncome, this.carrierShippingMethodParmas.minShippingFeeIncome
          ];
        }
      }
      if (this.carrierShippingMethodParmas.minGoodsQuantity > this.carrierShippingMethodParmas.maxGoodsQuantity) {
        [
          this.carrierShippingMethodParmas.minGoodsQuantity, this.carrierShippingMethodParmas.maxGoodsQuantity
        ] = [this.carrierShippingMethodParmas.maxGoodsQuantity, this.carrierShippingMethodParmas.minGoodsQuantity];
      }
    },
    saveNewOrderCarrierRule() {
      let v = this;
      let obj = {
        typeList: v.typeList,
        warehouseId: v.selectWareID
      };
      let apiUrl = v.pageType === 'distributor' ? api.put_ymslogisServiceProposalRule_batchUpdate : api.put_ymsCarrierProposalRule_batchUpdate;
      v.axios.put(apiUrl, obj).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
        }
      });
    },
    // 切换仓库
    getPlatformData(id) {
      let v = this;
      v.selectWareID = id;
      v.search();
      v.getCarrierRule();
      v.getCarrierScope();
      v.wareGroup.forEach((n, i) => {
        if (n.warehouseId === id) {
          n.selected = true;
          v.warehouseType = n.warehouseType;
          v.wareGroup.splice(i, 1);
          v.wareGroup.splice(0, 0, n);
        } else {
          n.selected = false;
        }
      });
    },
    // 获取仓库下拉列表
    getWareHouseNameList() {
      let v = this;
      let pos = [];
      getEnableWarehouseData(1).then((data) => {
        if (data.length > 0) {
          v.selectWareID = data[0].ymsWarehouseId;
          data.forEach((n, i) => {
            if (n.ymsWarehouseId === v.selectWareID) {
              pos.push({
                selected: true,
                warehouseId: n.ymsWarehouseId,
                title: n.name,
                warehouseType: n.warehouseType
              });
              v.warehouseType = n.warehouseType;
            } else {
              pos.push({
                selected: false,
                warehouseId: n.ymsWarehouseId,
                title: n.name,
                warehouseType: n.warehouseType
              });
            }
          });
          v.wareGroup = pos;
          v.$store.commit('warehouseList', pos);
          v.search();
          v.getCarrierRule();
          v.getCarrierScope();
        }
      });
    },
    // 运费/时效优先级
    getCarrierRule() {
      let v = this;
      let apiUrl = v.pageType === 'distributor' ? api.get_ymslogisServiceProposalRule_query : api.get_ymsCarrierProposalRule_query + '?warehouseId=' + v.selectWareID;
      v.axios.get(apiUrl).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data.length) {
            v.dataList = [];
            v.typeList = [];
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              v.$nextTick(() => {
                v.dataList.push(item.type);
              });
              v.typeList.push(item.type);
            }
          }
        }
      });
    },
    getList(apiUrl, params) {
      let v = this;
      v.axios.post(apiUrl, params).then(response => {
        if (response.data.code === 0) {
          let list = response.data.datas || [];
          v.logisticsData = list;
          v.tableLoading = false;
        }
      }).catch(() => {
        v.tableLoading = false;
      });
    },

    // 获取物流规则表格数据
    getLogisticsData(params) {
      let v = this;
      v.logisticsData = [];
      if (v.pageType === 'distributor' && v.getPermission('ymsCarrierAutoRule_query')) {
        v.getList(api.post_ymsLogisServiceAutoRule_query, params);
      } else {
        if (v.getPermission('ymsCarrierAutoRule_query')) {
          v.getList(api.post_ymsCarrierAutoRule_query, params);
        } else {
          v.gotoError();
        }
      }
    },
    // 新增物流规则
    addRule() {
      let v = this;
      v.editType = '0';
      v.ruleTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005347');
      v.ruleEditStatus = true;
      v.looKsettings = false;
      v.$nextTick(function () {
        v.ruleEditModel = true;
        v.ruleParmas = {
          editType: 'add',
          type: 1, // 0 edit 1 create
          name: '',
          autoRuleId: null,
          status: 0,
          businessId: v.selectWareID
        };
        v.$refs['ruleTemp'].open(v.ruleParmas);
      });
    },
    closeModal(value) {
      let v = this;
      v.ruleEditModel = false;
      if (value === 1) {
        v.search();
      }
    },
    endFunc(e) {
      let v = this;
      const oldIndex = e.oldIndex;
      const newIndex = e.newIndex;
      let obj;
      if (oldIndex === newIndex) {
        return false;
      }
      if (oldIndex > newIndex) { // 上移
        obj = {
          businessId: v.selectWareID,
          currentId: v.logisticsData[oldIndex].autoRuleId, // 规则ID
          previousId: newIndex > 0 ? v.logisticsData[newIndex - 1].autoRuleId : null
        };
        if (newIndex >= 0 && newIndex !== v.logisticsData.length - 1) {
          obj.nextId = v.logisticsData[newIndex + 1].autoRuleId; // 因为logisticsData并没有更新，所以newIndex取的是原来的位置
        }
      } else { // 下移
        obj = {
          businessId: v.selectWareID,
          currentId: v.logisticsData[oldIndex].autoRuleId, // 规则ID
          previousId: newIndex > 0 ? v.logisticsData[newIndex].autoRuleId : null // 因为logisticsData并没有更新，所以newIndex取的是原来的位置
        };
        if (newIndex >= 0 && newIndex !== v.logisticsData.length - 1) {
          obj.nextId = v.logisticsData[newIndex + 1].autoRuleId; // 因为logisticsData并没有更新，所以newIndex取的是原来的位置
        }
      }
      let apiUrl = v.pageType === 'distributor' ? api.put_ymsLogisServiceAutoRule_updatePriority : api.put_ymsCarrierAutoRule_updatePriority;
      v.axios.put(apiUrl, JSON.stringify(obj)).then(response => {
        if (response.data.code === 0) {
          v.search();
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
        }
      });
    },
    tableSort(autoRuleId, index, oldIndex) { // 优先级
      let v = this;
      let obj = {
        currentId: autoRuleId, // 规则ID
        previousId: index ? v.logisticsData[index].autoRuleId : null,
        priority: v.logisticsData[oldIndex].priority
      };
      if (!index && v.logisticsData.length > 1) {
        obj.nextId = v.logisticsData[0].autoRuleId;
      }
      let apiUrl = v.pageType === 'distributor' ? api.put_ymsLogisServiceAutoRule_updatePriority : api.put_ymsCarrierAutoRule_updatePriority;
      v.axios.put(apiUrl, obj).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          v.search();
        }
      });
    },
    // 启用  停用
    setStatus(autoRuleId, type) {
      let v = this;
      let url;
      if (type) {
        url = v.pageType === 'distributor' ? api.get_ymsLogisServiceAutoRule_disable : api.put_ymsCarrierAutoRule_disable;
      } else {
        url = v.pageType === 'distributor' ? api.get_ymsLogisServiceAutoRule_enable : api.put_ymsCarrierAutoRule_enable;
      }
      v.axios.put(url + autoRuleId).then(response => {
        if (response.data.code === 0) {
          v.search();
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
        }
      });
    },
    // 查询物流渠道适用范围列表
    getCarrierScope() {
      let v = this;
      v.scopeData = [];
      if (v.getPermission('ymsCarrierScopeRule_query')) {
        if (v.pageType === 'distributor') {
          v.handleScopeLogisticsChannelsData();
        } else {
          v.scopeLoading = true;
          v.axios.get(api.get_ymsCarrierScopeRule_query + '?warehouseId=' + v.selectWareID).then(response => {
            v.scopeLoading = false;
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              v.scopeData = data;
            }
          });
        }
      } else {
        v.gotoError();
      }
    },
    // 编辑
    editRowData(data) {
      let v = this;
      v.rowData = data;
      v.scopeModal = true;
      // 处理数据
      if (data.skuList) {
        v.skuList = data.skuList.toString();
      }
      if (this.system === 'distributor') {
        if (data.minShippingFeeIncome) {
          v.carrierShippingMethodParmas.minShippingFeeIncome = data.minShippingFeeIncome;
        }
      }
      if (data.maxShippingFeeIncome) {
        v.carrierShippingMethodParmas.maxShippingFeeIncome = data.maxShippingFeeIncome;
      }
      if (data.maxGoodsQuantity) {
        v.carrierShippingMethodParmas.maxGoodsQuantity = data.maxGoodsQuantity;
      }
      if (data.minGoodsQuantity) {
        v.carrierShippingMethodParmas.minGoodsQuantity = data.minGoodsQuantity;
      }
      if (data.maxPrice) {
        v.carrierShippingMethodParmas.maxPrice = data.maxPrice;
      }
      if (data.minPrice) {
        v.carrierShippingMethodParmas.minPrice = data.minPrice;
      }
      v.getModalData(data);
    },
    // 获取适用范围Modal所需数据
    getModalData(data) {
      let v = this;
      let list = [];
      let newList = data.ymsLogisServiceScopePlatformList || [];
      if (this.pageType === 'distributor') {
        if (data.extendJson) {
          list = JSON.parse(data.extendJson);
        }
        if (list && list.length) {
          v.platformIds = list;
          v.getPlatformStoreData(list).then(() => {
            v.accountIds = newList.map(i => i.saleAccountId);
          });
        }
        getEnabledPlatforms().then((data) => {
          if (data && data.length > 0) {
            v.platformList = data;
          }
        });
      } else {
        if (data.ymsCarrierScopePlatformList) {
          list = data.ymsCarrierScopePlatformList;
        }
        v.platformIds = [...new Set(list.map(i => i.platformId))];
        v.platformList = [{
          platformId: 'ebay',
          name: 'ebay',
        }];
      }
    },
    // 加载适用平台帐号列表
    setShopGroup(shopList, openList) {
      let v = this;
      let obj = {};
      let arrObj = {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
        expand: true,
        children: []
      };
      let platformGroup = v.$store.state.platformGroup;
      if (platformGroup.length > 0) {
        function makePlatformGroup() { // 读可用平台列表
          return new Promise(resolve => {
            for (let i = 0; i < platformGroup.length; i++) {
              if (!obj.hasOwnProperty(platformGroup[i].platformId)) {
                arrObj.children.push({
                  title: platformGroup[i].platformId,
                  saleAccountId: null,
                  expand: true,
                  children: []
                });
                obj[platformGroup[i].platformId] = arrObj.children.length - 1;
              }
              if (i === platformGroup.length - 1) {
                resolve(true);
              }
            }
          });
        }

        function makeRangeShopList() { // 适用平台帐号
          return new Promise(resolve => {
            for (let t = 0; t < shopList.length; t++) {
              let item = shopList[t];
              if (obj.hasOwnProperty(item.platformId) && openList.length > 0) {
                for (let i = 0; i < openList.length; i++) {
                  let sItem = openList[i];
                  let subItem = {
                    title: item.account,
                    saleAccountId: item.saleAccountId,
                    checked: (sItem.saleAccountId === item.saleAccountId && sItem.platformId === item.platformId) || (sItem.saleAccountId === null && sItem.platformId === item.platformId) || false,
                    platformId: item.platformId,
                    expand: false,
                    children: []
                  };
                  if (sItem.saleAccountId === null) {
                    arrObj.children.forEach((p, g) => {
                      if (p.title === sItem.platformId) {
                        p.checked = true;
                      }
                    });
                  }
                  if (sItem.platformId === item.platformId) {
                    arrObj.children[obj[item.platformId]].children.push(subItem);
                  }

                  if (t === shopList.length - 1) resolve(true);
                }
              } else if (obj.hasOwnProperty(item.platformId) && openList.length === 0) {
                let subItem = {
                  title: item.account,
                  saleAccountId: item.saleAccountId,
                  checked: false,
                  platformId: item.platformId,
                  expand: false,
                  children: []
                };
                arrObj.children[obj[item.platformId]].children.push(subItem);
                if (t === shopList.length - 1) resolve(true);
              }
            }
          });
        }

        function setShopAccount() {
          v.shopAccount = [arrObj];
        }

        async function getStartMakeShop() {
          const result = await makePlatformGroup();
          if (result) {
            const mslResult = await makeRangeShopList();
            if (mslResult) {
              await setShopAccount();
              v.$nextTick(function () {
                let selectNodes = this.$refs['shopAccountTree'].getCheckedNodes();
                v.$refs['shopAccountTree'].treeSelectGetValue(selectNodes);
              });
            }
          }
        }

        getStartMakeShop();
      }
    },
    makePlatformGroup() {
      let v = this;
      v.platformGroup = [{
        platformId: 'ebay',
        platformName: 'ebay',
      }];
    },
    // 试用平台帐号转化
    makeTreeToArr(treeData) {
      let arr = [];
      let obj = {};
      return new Promise(resolve => {
        treeData.forEach((n, i) => {
          if (n.platformId && !obj.hasOwnProperty(n.platformId)) {
            obj[n.platformId] = [n.saleAccountId];
          } else if (n.platformId && obj.hasOwnProperty(n.platformId) && obj[n.platformId] !== null) {
            obj[n.platformId].push(n.saleAccountId);
          } else if (!n.platformId && n.checked && n.saleAccountId === null) {
            obj[n.title] = null;
          }
        });
        for (let item in obj) {
          let newItem = {};
          newItem.platformId = item;
          newItem.saleAccountIds = obj[item];
          arr.push(newItem);
        }
        resolve([true, arr]);
      });
    },
    saveScope() {
      let v = this;
      let carrierPlatformList = [];
      carrierPlatformList = [];
      v.setNumber();
      let obj = {
        carrierId: v.rowData.carrierId,
        shippingMethodId: v.rowData.shippingMethodId,
        ymsWarehouseId: v.selectWareID,
        priceCurrency: 'USD',
        shippingFeeIncomeCurrency: 'USD',
        maxGoodsQuantity: v.carrierShippingMethodParmas.maxGoodsQuantity,
        minGoodsQuantity: v.carrierShippingMethodParmas.minGoodsQuantity,
        maxPrice: v.carrierShippingMethodParmas.maxPrice,
        minPrice: v.carrierShippingMethodParmas.minPrice,
        skuList: v.skuList ? v.skuList.split(',') : []
      };
      let apiUrl;
      let axiosType;
      if (v.pageType === 'distributor') {
        apiUrl = api.post_ymsLogisServiceScopeRule;
        axiosType = 'post';
        obj.ymsLogisServiceId = v.rowData.ymsLogisServiceId;
        obj.ymsLogisServiceScopeRuleId = v.rowData.ymsLogisServiceScopeRuleId;
        obj.minShippingFeeIncome = v.carrierShippingMethodParmas.minShippingFeeIncome;
        obj.maxShippingFeeIncome = v.carrierShippingMethodParmas.maxShippingFeeIncome;

        v.platformAccountList.forEach(i => {
          v.accountIds.map(k => {
            if (k === i.ymsPlatformAccountId) {
              carrierPlatformList.push({
                "merchantId": i.ymsPlatformAccountTokens ? i.ymsPlatformAccountTokens[0].merchantId : null,
                "platformId": i.platformId,
                "saleAccountId": i.ymsPlatformAccountId,
                "ymsLogisServiceScopePlatformId": v.rowData.ymsLogisServiceScopePlatformId,
                "ymsLogisServiceScopeRuleId": v.rowData.ymsLogisServiceScopeRuleId
              });
            }
          });
        });
        let pds = carrierPlatformList.map(i => i.platformId);
        v.platformIds.forEach(i => {
          if (!pds.includes(i)) {
            carrierPlatformList.push({
              platformId: i
            });
          }
        });
        obj.ymsLogisServiceScopePlatformList = carrierPlatformList;
      } else {
        apiUrl = api.put_ymsCarrierScopeRule;
        axiosType = 'put';
        obj.ymsCarrierScopeRuleId = v.rowData.ymsCarrierScopeRuleId;
        obj.ymsCarrierScopePlatformList = v.platformIds.map(i => {
          return {
            platformId: i
          };
        });
      }
      v.axios[axiosType](apiUrl, obj).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
          v.getCarrierScope();
          v.scopeModal = false;
        } else {
          v.scopeModalLoading = false;
          v.$nextTick(function () {
            v.scopeModalLoading = true;
          });
        }
      }).catch(() => {
        v.scopeModalLoading = false;
        v.$nextTick(function () {
          v.scopeModalLoading = true;
        });
      });
    },
    // 监听适用范围的弹窗
    scopeModalChange(value) {
      if (!value) {
        let v = this;
        v.skuList = '';
        v.platformIds = [];
        v.accountIds = [];
        v.shopAccountListModel = [];
        v.ownLogistics = false;
        v.extendJsonTalg = false;
        v.carrierShippingMethodParmas = {
          maxPrice: null,
          minPrice: 0,
          maxShippingFeeIncome: null,
          minShippingFeeIncome: 0,
          minEfficiency: 0,
          maxEfficiency: 0,
          minGoodsQuantity: 0,
          maxGoodsQuantity: null
        };
      }
    },
    // 在分销商系统中---选中规则指定发货指定方式
    selectYmsLogisServiceId(value) {
      let v = this;
      v.searchParams.shippingMethodIds = [];
      let ymsLogisServiceIds = v.uniqueFunc(value);
      if (ymsLogisServiceIds.length > 0) {
        v.getYmsLogisticsNameByIds(ymsLogisServiceIds).then(lData => {
          if (lData) {
            lData.forEach(k => {
              v.yunShipList.forEach(l => {
                if (k.ymsLogisServiceId === l.ymsLogisServiceId) {
                  if (k.ymsLogisServiceMappingList && k.ymsLogisServiceMappingList.length > 0) {
                    k.ymsLogisServiceMappingList.map((item) => {
                      v.searchParams.shippingMethodIds.push(item.shippingMethodId);
                    });
                  }
                }
              });
            });
          }
        });
      }
    },
    // 根据saleAccountId获取对应店铺的code
    getStoreCode(list) {
      let v = this;
      return new Promise(resolve => {
        if (list.length > 0) {
          v.axios.post(api.post_ymsPlatformAccount_queryYmsPlatformAccountByIds, list).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              resolve(data);
            }
          });
        } else {
          resolve(true);
        }
      });
    },
    // 分销商系统中处理物流渠道适用范围列表数据（包含云卖物流渠道、自有物流渠道）
    handleScopeLogisticsChannelsData() {
      let v = this;
      let ymsLogisServiceIds = [];
      let saleAccountIds = [];
      v.scopeLoading = true;
      v.axios.get(api.get_ymsLogisServiceScopeRule_query).then(response => {
        v.scopeLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data && data.length > 0) {
            data.forEach((n, i) => {
              if (n.ymsLogisServiceId) {
                ymsLogisServiceIds.push(n.ymsLogisServiceId);
              }
              if (n.ymsLogisServiceScopePlatformList && n.ymsLogisServiceScopePlatformList.length > 0) {
                n.ymsLogisServiceScopePlatformList.map((item) => {
                  saleAccountIds.push(item.saleAccountId);
                });
              }
            });
            if (ymsLogisServiceIds.length > 0) {
              let list = v.uniqueFunc(saleAccountIds);
              Promise.all([v.getYmsLogisticsNameByIds(ymsLogisServiceIds), getOwnLogisticsChannel(), v.getStoreCode(list)]).then(result => {
                let data1 = result[0];
                let data2 = result[1];
                let data3 = result[2];
                if (data1 && data1.length > 0) {
                  data1.forEach(k => {
                    data.forEach(l => {
                      if (k.ymsLogisServiceId === l.ymsLogisServiceId) {
                        l.ymsLogisticsName = _handleMultilingualFields(k.name);
                        l.isOwnLogistics = 0;
                      }
                    });
                  });
                }
                if (data2.length > 0) {
                  data.map((item) => {
                    data2.map((ele) => {
                      if (ele.carrierId === item.carrierId) {
                        item.ymsLogisticsName = ele.carrierName;
                        item.isOwnLogistics = 1;
                        item.extendJson = ele.extendJson;
                      }
                    });
                  });
                }
                if (data3.length > 0) {
                  data.map((item) => {
                    data3.map((ele) => {
                      if (item.ymsLogisServiceScopePlatformList) {
                        item.ymsLogisServiceScopePlatformList.map((talg) => {
                          if (talg.saleAccountId === ele.ymsPlatformAccountId) {
                            talg.saleAccountName = ele.code;
                          }
                        });
                      }
                    });
                  });
                }
                v.scopeData = data;
              });
            }
          }
        }
      });
    }
  },
  mounted() {
    let v = this;
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    let todoList = document.getElementById('moveDragContainer');
    if (v.getPermission('ymsCarrierProposalRule_query')) {
      Sortable.create(todoList, {
        group: {
          name: 'list',
          pull: true
        },
        animation: 120,
        ghostClass: 'placeholder-style',
        onUpdate(event) {
          let newIndex = event.newIndex;
          let oldIndex = event.oldIndex;
          let item = v.typeList[oldIndex];
          v.typeList.splice(oldIndex, 1);
          v.typeList.splice(newIndex, 0, item);
          v.saveNewOrderCarrierRule();
        }
      });
      sortEl = v.$refs.dragable.$children[1].$el.children[1];
      Sortable.create(sortEl, {
        onEnd: v.endFunc
      });
    } else {
      v.gotoError();
    }
    if (this.pageType !== 'distributor') {
      v.makePlatformGroup();
    }
  }
};
</script>

<style lang="less" scoped>
.f-wid {
  min-width: 200px;
  width: 300px;
}

.explain_box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;

  .explain_box_item {
    min-width: 110px;
    padding: 0 15px;
    height: 40px;
    //background-color: #fff;
    color: #fff;
    border-radius: 5px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
      font-weight: 700;
      margin-right: 15px;
    }
  }


  .tooltip_box_style {
    h3 {
      font-size: 14px;
      color: #333;
      font-weight: bold;
      margin-bottom: 4px;
    }

    p {
      margin-top: 6px;
      color: #333;
      font-size: 13px;
    }
  }
}

.distributorTheme {
  .explain_box_item {
    //background-color: #FD5425;
    border: 2px solid #FD5425;
    color: #FD5425;
  }
}

.ymsTheme {
  .explain_box_item {
    //background-color: #32a6d9;
    border: 2px solid #32a6d9;
    color: #32a6d9;
  }
}

.warehouse_box_styls {
  display: flex;
  align-items: center;
  margin: 0 0 15px 0;

  .text {
    padding-left: 15px;
    height: 32px;
    line-height: 32px;
    display: inline-block;
  }
}

.reset_card_head_style {
  /deep/ .ivu-card-head {
    padding: 7px 16px;
  }
}

.priority_box {
  display: flex;
  align-items: center;

  .normalRMargin {
    font-size: 16px;
    margin: 0 5px;
  }
}

.text-center {
  text-align: center;
}

.moveDragContainer {
  margin: 30px 0;
}

.moveDragContainer .moveDrag {
  margin: 0 20px;
  border: 1px solid #eee;
  padding: 10px 20px;
  cursor: move;
}

.ruleTable {
  padding: 0 12px;
  margin-top: 10px;
}

.smart-search {
  margin: 5px 0 0 25px;
}

.pseudoButton {
  position: relative;
  float: left;
  margin-left: -1px;
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  white-space: nowrap;
  line-height: 1.5;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 6px 15px;
  font-size: 12px;
  border-radius: 4px;
  transition: color .2s linear, background-color .2s linear, border .2s linear;
  color: #495060;
  background-color: #f7f7f7;
  border: 1px solid #dddee1;
}

.pseudoButton:not(:first-child):not(:last-child) {
  border-radius: 0
}

.ivu-btn-group:not(.ivu-btn-group-vertical) > .pseudoButton:last-child:not(:first-child) {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.distributorTreeStyle {
  /deep/ .ivu-treeSelect-visible .ivu-treeSelect-selection {
    border-color: #FD5425;
    box-shadow: 0 0 0 2px rgba(253, 84, 37, 0.2)
  }

  /deep/ .ivu-treeSelect-selection:hover {
    border-color: #FD5425;
  }
}

</style>
